import React, { useEffect, useState } from "react";
import API from "../../utils/api";

const Carousel = () => {
  const [heroes, setHeroes] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const fetchHeroes = async () => {
    try {
      const res = await API.get("/hero/get-all-hero");
      setHeroes(res.data?.hero || []);
    } catch (err) {
      console.error("Error fetching heroes", err);
    }
  };

  useEffect(() => {
    fetchHeroes();
  }, []);

  useEffect(() => {
    if (heroes.length === 0) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % heroes.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [heroes]);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % heroes.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? heroes.length - 1 : prev - 1));
  };

  return (
    <div className="relative w-full h-[650px] overflow-hidden">
      {/* Slides */}
      <div
        className="flex transition-transform duration-700 ease-in-out h-full"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {heroes.map((hero, index) => (
          <div key={hero._id} className="w-full h-full flex-shrink-0 relative">
            <img
              src={hero.image}
              alt={hero.heading}
              className="w-full h-full object-cover"
              loading="lazy"
            />

            {/* Overlay */}
            <div className="absolute inset-0 bg-black/60" />

            {/* Content */}
            <div className="absolute inset-0 flex items-center px-6 md:px-16">
              <div className="max-w-3xl text-white">
                <h2 className="md:hidden text-2xl md:text-6xl font-bold mb-3  tracking-wider">
                  {hero.heading}
                </h2>
                <h2 className="hidden md:block text-2xl md:text-6xl font-bold mb-3 leading-loose tracking-wider">
                  {hero.heading}
                </h2>
                <p className="text-sm md:text-2xl text-gray-200 mt-5 md:mt-10 tracking-wider">
                  {hero.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Arrows */}
      {heroes.length > 1 && (
        <>
          <button
            onClick={prevSlide}
            className="absolute top-1/2 left-4 -translate-y-1/2 bg-black/40 text-white px-3 py-2 rounded-full hover:bg-black/70"
          >
            ❮
          </button>

          <button
            onClick={nextSlide}
            className="absolute top-1/2 right-4 -translate-y-1/2 bg-black/40 text-white px-3 py-2 rounded-full hover:bg-black/70"
          >
            ❯
          </button>
        </>
      )}

      {/* Dots */}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
        {heroes.map((_, index) => (
          <div
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`h-3 w-3 rounded-full cursor-pointer transition ${
              currentIndex === index ? "bg-white scale-110" : "bg-white/50"
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default Carousel;
